module.exports = __webpack_public_path__ + "img/brand-cases24.15c1a788.png";